import { createReducer, createAction } from '@reduxjs/toolkit';
import User from 'types/User';
import { SessionSlice } from 'types/State';

export const setHasClosedAdhesionAd = createAction('session/hasClosedAdhesionAd');

export const signedIn = createAction<User>('session/signedIn');
export const signedOut = createAction('session/signedOut');
export const isPaidReceived = createAction<boolean>('session/isPaidReceived');

const initialState: SessionSlice = {
  hasClosedAdhesionAd: false,
  isSignedIn: undefined,
  isPaid: false,
};

export const sessionReducer = createReducer(initialState, {
  [isPaidReceived.type]: (state, action) => {
    return { ...state, isPaidReceived: action.payload };
  },

  [setHasClosedAdhesionAd.type]: (state) => {
    return { ...state, hasClosedAdhesionAd: true };
  },
  [signedIn.type]: (state) => {
    return { ...state, isSignedIn: true };
  },
  [signedOut.type]: (state) => {
    return { ...state, isSignedIn: false };
  },
});
